import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpParams,
} from "@angular/common/http";
import { Observable, throwError, of } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { SessionExpiredService } from "./session-expired-service";
import { IAppConfig } from "../core/models/app-config.model";
import { AppConfig } from "../design/app";
import { IApiResponse } from "../core/models/api-response.model";
import { MasterData } from "../models/master-model";
import { Coordinator } from "../models/coordinator";
import { SessionSearchResult } from "../models/SessionSearchResult";
import { SessionModel } from "../models/SessionModel";
import { SessionResult } from "../models/SessionResult";
import { FacilitatorResult } from "../models/FacilitatorResult";
import { SubscriptionMetaData, SubscriptionAdmin } from "../models/SubscriptionMetaData";
const urlsStartPoint = "";

const Urls: Array<string> = [
  urlsStartPoint + "/api/GetCompanies?searchword={term}&count={count}",
  urlsStartPoint + "api/GetPPMDs?count={count}&searchText={term}",
  urlsStartPoint + "api/AllCoordinators?count={count}&searchText={term}",
];

@Injectable({
  providedIn: "root",
})
export class SessionService {
  appConfig: any;
  baseUrl;
  facilitatorBaseUrl;
  constructor(private http: HttpClient, private _sessionExpiredService: SessionExpiredService) {
    this.appConfig = AppConfig;
    this.baseUrl = this.appConfig.session.baseUrl;
    this.facilitatorBaseUrl = this.appConfig.facilitator.baseUrl;

  }

  dropdownData: any;

  public getSearchSession(inputData: any): Observable<IApiResponse<SessionSearchResult>> {
    let apiUrl: string;
    if (inputData.SessionData === 'f8c3cd1f-7532-466f-87ee-b9cbb47abf1b' || inputData.SessionData === '7a034772-1b9d-45b3-b3c4-2b104006462f') {
      //Commented code removed - sonar suggesstion
    } else {
      const getSessionSearchData = this.appConfig.session.getSessionSearchData;
      apiUrl = `${this.baseUrl + getSessionSearchData}`;
      return this.http.post<IApiResponse<SessionSearchResult>>(apiUrl, inputData);
    }
  }


  public exportReport(inputData: any): Observable<Uint8Array> {
    const sessionExport = this.appConfig.session.sessionExport;
    const apiUrl = `${this.baseUrl + sessionExport}`;
    return this.http.post(apiUrl, inputData, { responseType: 'arraybuffer' }).pipe(
      map(response => {
        this._sessionExpiredService.resetTimer();
        return new Uint8Array(response);
      }),
      catchError(this.handleError)
    );
  }

  emailDownload(addSession: any, sessionId, subjectName): Observable<any> {
    const CreateAcknolwedgementEmail = this.appConfig.session.CreateAcknolwedgementEmail;
    const apiUrl = `${this.baseUrl + CreateAcknolwedgementEmail}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    const criteria = JSON.stringify(addSession);
    return this.http.post(apiUrl + subjectName, criteria, { headers, responseType: 'arraybuffer' }).pipe(
      map(response => {
        this._sessionExpiredService.resetTimer();
        return new Uint8Array(response);
      }),
      catchError(this.handleError)
    );
  }
  getEditSessionData(sessionId: string): Observable<IApiResponse<SessionModel>> {
    if (sessionId) {
      const getEditSession = this.appConfig.session.getEditSession;
      const apiUrl = `${this.baseUrl + getEditSession}?sessionId=${sessionId}`;
      return this.http.get<IApiResponse<SessionModel>>(apiUrl);

    } else {
      return of({ Success: false, Data: null, Message: "" });
    }
  }

  searchSession(term: string, target: number) {
    const apiUrl: string =
      urlsStartPoint + "/api/SessionData/?searchSession={term}";

    const sessionSearchURL = apiUrl[target].replace("{term}", term);
    return this.http
      .get(sessionSearchURL)
      .pipe(
        map((response) =>
          target === 1 ? JSON.parse(response.toString()) : response
        )
      );
  }

  searchword(term: string, target: number) {
    //Bug 3684649 fix
    if (term === undefined || term === null || term === "" || term.length <= 2) {
      return of([]);
    }
    const headers = new HttpHeaders();
    const count = this.appConfig.searchCount ? this.appConfig.searchCount : "15";
    const countryURL = `${this.baseUrl}` + Urls[target].replace("{term}", term).replace("{count}", count);
    if (target == 0) {
      const getCompanies = this.appConfig.session.getCompanies;
      const apiUrl = `${this.baseUrl + getCompanies}`;
      const request = {
        CompanyName: term,
        Count: this.appConfig.searchCount
      }
      return this.http.post<IApiResponse<any>>(apiUrl, request, { headers: headers }).pipe(
        map((res) => res.Data),
        catchError(this.handleError))
    }
    else {
      return this.http
        .get<IApiResponse<any>>(countryURL)
        .pipe(
          map((response) =>
            response.Data
          )
        );
    }
  }

  searchFacilitator(facilitatorLength: number,
    term: string,
    CertificationlevelID: number,
    sesstionTypes: number,
    contentArea: number,
    topic: number,
    sessionTypesEvent: number,
    sessionAudience: number) {
    //Bug 3684649 fix
    const headers = new HttpHeaders();
    const getFacilitators = this.appConfig.facilitator.getFacilitators;
    const apiUrl = `${this.facilitatorBaseUrl + getFacilitators}?searchText=${term}&count=${facilitatorLength}&levelID=${CertificationlevelID}&sessionTypes=${sesstionTypes}&contentArea=${contentArea}&topic=${topic}&stEvent=${sessionTypesEvent}&sessionAudience=${sessionAudience}`;
    return this.http
      .get<IApiResponse<FacilitatorResult[]>>(apiUrl, { headers: headers })
      .pipe(
        map((response) => response.Data)
      );
  }

  public addSession(addSession: any, sessionId): Observable<IApiResponse<SessionResult>> {
    const endpoint = this.appConfig.session.addOrUpdateSession;
    const apiUrl = `${this.baseUrl + endpoint}?session_Id=${sessionId}`;

    return this.http
      .post<IApiResponse<SessionResult>>(apiUrl, addSession)
      .pipe(catchError(this.handleError));
  }
  public getSessionDropdrownData(): Observable<any> {
    const endpoint = this.appConfig.session.getMaterData;
    const apiUrl = `${this.baseUrl + endpoint}`;
    const headers = new HttpHeaders();
    return this.http.get<IApiResponse<MasterData>>(apiUrl + "?returnDeloittedata=true&IsIncludeNA=true", { headers: headers }).pipe(
      map((res) => {
        return res.Data;
      }),
      catchError(this.handleError)
    );
  }
  public getSessionAllFacilitatorsData(): Observable<any> {
    const apiUrl: string = urlsStartPoint + "api/CreateSession/AllFacilitators";
    const headers = new HttpHeaders();
    return this.http.get(apiUrl, { headers: headers }).pipe(
      map((res) => res),
      catchError(this.handleError)
    );
  }

  public getSessionAllCoordinatorsData(): Observable<IApiResponse<Coordinator[]>> {
    const getAllCoordinators = this.appConfig.session.getAllCoordinators;
    const apiUrl = `${this.baseUrl + getAllCoordinators}`;
    const headers = new HttpHeaders();
    return this.http.get<IApiResponse<Coordinator[]>>(apiUrl, { headers: headers }).pipe(
      map((res) => res),
      catchError(this.handleError)
    );
  }
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error("An error occurred:", error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    return throwError("Something bad happened; please try again later.");
  }

  getSubscriptionData(id): Observable<IApiResponse<SubscriptionMetaData>> {
    const getEditSession = this.appConfig.session.getSubscriptionMetaData;
    const apiUrl = `${this.baseUrl + getEditSession}?SubscriptionUniqueID=${id}`;
    return this.http.get<IApiResponse<SubscriptionMetaData>>(apiUrl);
  }

  getEditSession(id): Observable<IApiResponse<SessionModel>> {
    const getEditSession = this.appConfig.session.getEditSession;
    const apiUrl = `${this.baseUrl + getEditSession}?id=${id}`;
    return this.http.get<IApiResponse<SessionModel>>(apiUrl);
  }

  getSubscriptionDataAsPrmose(id) {
    const apiUrl: string =
      urlsStartPoint +
      "api/Subscription/GetSubscriptionMetaData?SubscriptionUniqueID=" +
      id;
    const headers = new HttpHeaders();
    return this.http.get(apiUrl, { headers: headers }).toPromise();
  }

  public exportAuditTrailReport(id: any): Observable<Uint8Array> {
    const sessionID = Number(id);

    const sessionAuditTrailExport = this.appConfig.session.sessionAuditTrailExport;
    const apiUrl = `${this.baseUrl + sessionAuditTrailExport}`;
    return this.http.post(apiUrl, sessionID, { responseType: 'arraybuffer' }).pipe(
      map(res => {
        this._sessionExpiredService.resetTimer()
        return new Uint8Array(res);
      }));
  }

  //Subscription Usage Report
  public exportSubsUsageReport(subscriptionId: any): Observable<Uint8Array> {
    const exportSubsUsageReport = this.appConfig.session.exportSubsUsageReport;
    const apiUrl = `${this.baseUrl + exportSubsUsageReport}?subscriptionUniqueID=${subscriptionId}`;
    return this.http.post(apiUrl, subscriptionId, { responseType: 'arraybuffer' }).pipe(
      map(response => {
        this._sessionExpiredService.resetTimer();
        return new Uint8Array(response);
      }),
      catchError(this.handleError)
    );
  }

  // Get WBS Codes for typeahead dropdown
  getWBSCodes(searchText: string): Observable<any[]> {
    if (!searchText || searchText.length < 22) {
      return of([]);
    }
    const GetWBSCodes = this.appConfig.session.GetWBSCodes;
    const apiUrl = `${this.baseUrl + GetWBSCodes}?searchText=${encodeURIComponent(searchText)}`;
    return this.http.get<IApiResponse<any>>(apiUrl).pipe(
      map((response) => {
        // Extract WbsElements from nested response structure
        const wbsElements = response.Data?.Wbs?.WbsElements;
        return wbsElements ? [wbsElements] : [];
      }),
      catchError(() => of([]))
    );
  }

  // Get user specific search grid

  getUserSpecificSearchGrid(userId: string, page: string): Observable<any[]> {
    const GetUserSpecificSearchGrid = this.appConfig.session.GetUserSpecificSearchGrid;
    const apiUrl = `${this.baseUrl + GetUserSpecificSearchGrid}?userId=${encodeURIComponent(userId)}&page=${encodeURIComponent(page)}`;
    return this.http.get<IApiResponse<any>>(apiUrl).pipe(
      map((response) => {
        return response.Data;
      }),
      catchError(() => of([]))
    );
  }

  // save user specific search grid

  saveUserSpecificSearchGrid(userId: string, page: string, data: any): Observable<any> {
    const SaveUserSpecificSearchGrid = this.appConfig.session.SaveUserSpecificSearchGrid;
    const apiUrl = `${this.baseUrl + SaveUserSpecificSearchGrid}?userId=${encodeURIComponent(userId)}&page=${encodeURIComponent(page)}`;
    return this.http.post<IApiResponse<any>>(apiUrl, data).pipe(
      map((response) => response),
      catchError(() => of([]))
    );
  }

}


